import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const ProductCardNameUI = t0 => {
  const $ = _c(6);
  const {
    isHotspotCard: t1,
    isModularSofasPage: t2,
    name
  } = t0;
  const isHotspotCard = t1 === undefined ? false : t1;
  const isModularSofasPage = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isHotspotCard || $[1] !== isModularSofasPage) {
    t3 = classNames("text-xs font-bold text-gray mt-2 mx-0 mb-0 lg:mt-3.5 xl:text-sm xl:tracking-[.0187rem] xl:font-bold xl:leading-[1.2rem] xl:mb-0.5", {
      "md:!mt-2": isModularSofasPage,
      "lg:!mt-0": isHotspotCard
    });
    $[0] = isHotspotCard;
    $[1] = isModularSofasPage;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== name || $[4] !== t3) {
    t4 = <h3 className={t3} data-name="top-left-product-img-description" data-xc="top-left-product-img-description">{name}</h3>;
    $[3] = name;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
ProductCardNameUI.propTypes = {
  isHotspotCard: PropTypes.bool,
  isModularSofasPage: PropTypes.bool,
  name: PropTypes.string
};
export default ProductCardNameUI;